import React from 'react';
import Chart from 'react-apexcharts';

// const PieChart = (props) => {
//     const series = [44, 55, 25, 43, 22, 18];

//     const options = {
//         chart: {
//             type: 'pie',
//         },

//         labels: ['Marketing', 'Sales', 'Development', 'Support', 'HR', 'Finance'],

//         legend: {
//             show: false, // ✅ hide legend
//         },

//         plotOptions: {
//             pie: {
//                 dataLabels: {
//                     offset: -5,
//                 },

//             },
//         },
//         dataLabels: {
//             enabled: true,
//             style: {
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 colors: ['#000']
//             },
//             dropShadow: {
//                 enabled: false
//             }
//         },

//         responsive: [
//             {
//                 breakpoint: 480,
//                 options: {
//                     chart: {
//                         width: 300,
//                     },
//                     legend: {
//                         position: 'bottom',
//                     },
//                 },
//             },
//         ],

//         //Rotate labels
//         stroke: {
//             show: true,
//             width: 1,
//             colors: ['#ccc'], // border color between slices
//         },
//     };

//     return (
//         <div style={{ maxWidth: 420, margin: '0 auto' }}>
//             <Chart options={options} series={series} type="pie" />
//         </div>
//     );
// };

const PieChart = ({ chartData }) => {
  if (!chartData?.datasets) return null;

  const metric = chartData.defaultMetric || "clicks";
  const dataset = chartData.datasets[metric] || [];

  const series = dataset.map(item => item.value);
  const labels = dataset.map(item => item.name);

  const total = series.reduce((sum, val) => sum + val, 0);

  const options = {
    chart: {
      type: "pie",
    },
    labels,
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -5,
          minAngleToShowLabel: 0,
        },
      },
    },

    // 🔹 SHOW % INSIDE PIE
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const value = series[opts.seriesIndex];
        if (!total || !value) return "0%";

        const percent = ((value / total) * 100).toFixed(1);
        return `${percent}%`;
      },
      style: {
        fontSize: "10px",
        fontWeight: "600",
        colors: ["#000"],
      },
      dropShadow: {
        enabled: false,
      },
    },

    stroke: {
      show: true,
      width: 1,
      colors: ["#ccc"],
    },

    // 🔹 SHOW RAW NUMBERS ON HOVER
    tooltip: {
      y: {
        formatter: val => {
          if (metric === "spend") return `$${val}`;
          if (metric === "impressions") return `${val} impressions`;
          return `${val} clicks`;
        },
        title: {
          formatter: seriesName => seriesName,
        },
      },
    },
  };

  return (
    <div style={{ maxWidth: 420, margin: "0 auto" }}>
      <Chart options={options} series={series} type="pie" />
    </div>
  );
};


export default PieChart;
